module.exports = "<button class=\"btn btn-sm my-btn mx-1\" (click)=\"buttonClicked()\"  >{{buttonText}}</button>\r\n"